import API from 'constants/API';
import {Routes} from 'constants/routes';

import {useState} from 'react';

import Button from 'components/Button/Button';
import FormError from 'components/FormError/FormError';
import Icon from 'components/Icon/Icon';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import {useNavigate, Link} from 'react-router-dom';
import httpClient from 'utils/httpClient/httpClient';

import resetSchema from './resetSchema';
import './ResetPassword.scss';

export const ResetPassword = () => {
  const navigate = useNavigate();
  const [success, setSuccess] = useState<boolean>(false);

  const onSubmit = async (values: {password: string}) => {
    const searchParams = new URLSearchParams(window.location.search);
    const passwordResetToken = searchParams.get('reset_password_token');

    const dto = {reset_password_token: passwordResetToken, password: values.password};

    try {
      await httpClient.put(`${API.AUTH_SERVICE.PASSWORD}`, {user: dto});
      setSuccess(true);
    } catch (error) {
      // eslint-disable-next-line
      console.error(error);
    }
  };

  return (
    <div className="reset-password-page">
      <div className="reset-password-page__cloud-up" />
      <div className="reset-password-page__header">
        <Link to={Routes.HOME}>
          <Icon icon="login_logo" />
        </Link>
      </div>
      {success ? (
        <div className="reset-password-page__welcome">
          <h1 className="reset-password-page__welcome-title">Password is successfully updated!</h1>
          <h2 className="reset-password-page__welcome-subtitle">
            Return to the log in screen and enter the new password.
          </h2>
        </div>
      ) : (
        <div className="reset-password-page__welcome">
          <h1 className="reset-password-page__welcome-title">Reset Password</h1>
          <h2 className="reset-password-page__welcome-subtitle">Enter new password below</h2>
        </div>
      )}
      {!success ? (
        <Formik initialValues={{password: ''}} onSubmit={onSubmit} validationSchema={resetSchema}>
          <Form className="reset-password-page__form">
            <div className="reset-password-page__form-control">
              <label className="reset-password-page__form-label">
                <Icon icon="lock" />
                <Field name="password" type="password" placeholder="New Password" className="login-page__form-input" />
              </label>
              <ErrorMessage name="password">{(msg) => <FormError message={msg} />}</ErrorMessage>
            </div>
            <div className="reset-password-page__form-control">
              <label className="reset-password-page__form-label">
                <Icon icon="lock" />
                <Field
                  name="password_confirmation"
                  type="password"
                  placeholder="Enter confirm password"
                  className="login-page__form-input"
                />
              </label>

              <ErrorMessage name="password_confirmation">{(msg) => <FormError message={msg} />}</ErrorMessage>
            </div>

            <div className="reset-password-page__cloud-down">
              <div className="reset-password-page__actions">
                <Button variant="tertiary" type="submit" className="reset-password-page__reset-btn">
                  Reset Password
                </Button>
                <span className="reset-password-page__already-account">
                  Go back to{' '}
                  <button
                    className="reset-password-page__signin-link"
                    onClick={() => {
                      window.location.href = 'tapspots://login';
                      navigate(Routes.LOGIN);
                    }}
                  >
                    Sign In
                  </button>
                </span>
              </div>
            </div>
          </Form>
        </Formik>
      ) : (
        <>
          <div className="reset-password-page__cloud-down">
            <div className="reset-password-page__actions">
              <Button
                variant="tertiary"
                className="reset-password-page__reset-btn text-center"
                onClick={() => {
                  window.location.href = 'tapspots://login';
                  navigate(Routes.LOGIN);
                }}
              >
                Return to login
              </Button>
            </div>
          </div>
        </>
      )}
      <div className="reset-password-page__footer" />
    </div>
  );
};
